import { VimsSFTPState, VimsSFTPActionTypes, vimsSFTPActionNames } from './types';

const initialState: VimsSFTPState = {
  fileId: "",
  isLoading: false
};

export const vimsSFTPReportReducer = (
  state: VimsSFTPState = initialState,
  action: VimsSFTPActionTypes,
): VimsSFTPState => {
  switch (action.type) {
    case vimsSFTPActionNames.SET_VIMS_SFTP_FILE_ID: {
      return {
        ...state,
        fileId: action.payload?.fileId,
      };
    }
    case vimsSFTPActionNames.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    default:
      return state;
  }
};
